import {User} from '@drl/core/auth/models/user.model';

export class Notification {
  id?: string;
  subject?: string;
  body: string;
  receiver: Receiver;
  type: MessageType;
  sent: string;// sonarignore:start
  options?: any;
  notificationTime?: string;// sonarignore:end
  messageTitle?: string;
  messageBody?: string;
  photo?: string;
  isRead?: boolean;
}

export class AlertNotification extends Notification {
  patient: User;
  alertId?: number;
}

export const enum MessageType {
  Push,
  Email,
  SMS,
}

export interface Receiver {
  // sonarignore:start
  to: any[];
  // sonarignore:end
}
